import type { ConnectedBookingData } from "../../../features/Booking-Form/typings/connected-bookingData";
import type { FloorAvailability } from "../../../features/FloorManager/typings/floor-inventory.entity";

/**
 * Collects `currentFloor.connectedBookingData` rows for each selected colleague's `userId`,
 * then de-duplicates by `(userId, bookingInventoryId)` so the floor plan can
 * highlight initials without duplicate entries.
 * A missing `currentFloor`, or missing/undefined `connectedBookingData`, is treated as no rows.
 */
export function getUniqueConnectedBookingsForColleagueFilter(
  selectedColleagueFilter: readonly Pick<ConnectedBookingData, "userId">[],
  currentFloor: FloorAvailability | undefined
): ConnectedBookingData[] {
  const connectedBookingData = currentFloor?.connectedBookingData ?? [];

  return selectedColleagueFilter
    .flatMap(colleague => connectedBookingData.filter(entry => entry.userId === colleague.userId))
    .reduce((acc: ConnectedBookingData[], entry) => {
      const alreadyPresent = acc.some(
        item => item.bookingInventoryId === entry.bookingInventoryId && item.userId === entry.userId
      );
      if (!alreadyPresent) {
        acc.push(entry);
      }
      return acc;
    }, []);
}
